<template>
  <div id="contract-filter-box" @show="reset">
    <toggle-box
      :text="$t('FILTERS')"
      white
      pure-icon
      ref="box"
      @close="cancel"
    >
      <template v-slot:icon>
        <font-awesome-icon class="icon" :icon="faFilter" />
      </template>

      <template v-slot:content>
        <div class="filters-contracts">
          <bamboo-input
            :items="listStatus"
            :label="$t('STATUS')"
            v-model="status"
            required
            multiple
            ref="statusInput"
          />
        </div>
        <div class="btns">
          <primary-button :text="$t('CLEAR')" rounded-corner independence @click="clear" />
          <primary-button :text="$t('FILTER')" rounded-corner independence @click="apply" />
        </div>
      </template>
    </toggle-box>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

import ToggleBox from '@/components/ToggleBox';
import BambooInput from '@/components/BambooInput';
import PrimaryButton from '@/components/PrimaryButton';
import { CONTRACT_STATUSES } from '@/consts';

const { useState, useActions } = createNamespacedHelpers('contractList');

export default {
  components: {
    FontAwesomeIcon,
    ToggleBox,
    BambooInput,
    PrimaryButton,
  },
  setup(props, { root }) {
    const { filters } = useState(['items', 'filters', 'total']);
    const { applyFilter } = useActions(['applyFilter']);

    const listStatus = computed(() => Object.keys(CONTRACT_STATUSES).map((s) => ({
      value: s,
      text: root.$t(s)
    })));

    const box = ref(null);
    const status = ref(filters.status || listStatus.value.map((item) => item.value));
    const statusInput = ref('');

    const cancel = () => {
      box.value.toggle(false);
    };

    const reset = () => {
    };

    const apply = () => {
      const inputs = [
        statusInput.value
      ];
      let valid = true;

      inputs.forEach((input) => {
        const inputValidity = input.validateInput();
        valid = valid && inputValidity;
      });

      if(valid) {
        applyFilter({
          page: 1,
          status: status.value,
          fromDate: null
        });

        box.value.toggle(false);
      }
    };

    const clear = (e) => {
      e.stopPropagation();

      status.value = listStatus.value.map((item) => item.value);
    };

    return {
      box,
      faFilter,
      cancel,
      apply,
      filters,
      clear,
      reset,
      CONTRACT_STATUSES,
      status,
      listStatus,
      statusInput
    };
  }
};
</script>

<style lang="scss">
@import '~@/assets/scss/colors';

#contract-filter-box {
  .filters-contracts {
    width: 700px;

    .amounts {
      display: flex;
      align-items: top;
      justify-content: space-between;

        .text-input {
          width: calc(50% - 5px);

          input {
            width: 100%;
            border-radius: 4px;
          }
        }
    }

    .input {
      margin-bottom: 20px;
    }
  }
  .btns {
    text-align: right;
    margin-top: 15px;
    margin-bottom: 5px;

    .primary-button {
      margin-left: 10px;
      padding-left: 20px;
      padding-right: 20px;
    }
  }
}
</style>
